
namespace Gamification.Gamification {
    export class ChecklistColumns {
        static columnsKey = 'Gamification.Checklist';
    }
}